import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";

class DropdownTabs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options,
            disabled: this.props.disabled,
            error: this.props.error,
            value: this.props.value
        };
    };

    componentWillMount() {};

    componentDidMount(){
        this.setState({
            options: this.props.options,
            value: this.props.value
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            options: nextProps.options,
            disabled: nextProps.disabled,
            error: nextProps.error,
            value: nextProps.value
        });
    }

    functions = {
        select: (value) => {
            this.props.onChange(value);
        }
    };

    renders = {};

    render() {
        return (
            <div className={cx(Styles.tabsContainer)}>
                {
                    this.state.options.map((item) => {
                        return(
                            <div onClick={() => {
                                if(!this.state.disabled){
                                    this.functions.select(item)
                                }
                            }} className={
                                cx(Styles.tabsContainerItem,
                                    {
                                        [Styles.tabsContainerItemActive]: this.state.value.id === item.id,
                                    })
                            }>
                                {item.title}
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default DropdownTabs;


// WEBPACK FOOTER //
// ./src/components/dropdown-tabs/component.js